import React, { useEffect } from 'react';

const IOS_APP_URL = 'https://apps.apple.com/app/fieldworker/id1529488939';
const ANDROID_APP_URL = 'https://play.google.com/store/apps/details?id=com.analytiq.fieldworkerprod';

const MobileAppDownload = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.replace(IOS_APP_URL);
    } else if (/android/i.test(userAgent)) {
      window.location.replace(ANDROID_APP_URL);
    }
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
      background: 'linear-gradient(135deg, #0b61e2 0%, #bed2e7 100%)',
      color: '#333',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '420px',
        padding: '40px',
        borderRadius: '12px',
        backgroundColor: 'white',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px', color: '#0b61e2' }}>
          <i className="fas fa-mobile-alt"></i>
        </div>
        <h1 style={{ color: '#0b61e2', marginBottom: '20px', fontSize: '28px', fontWeight: 600 }}>
          Download FieldWorker
        </h1>
        <p style={{ marginBottom: '24px' }}>
          Choose your platform:
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <a href={IOS_APP_URL} style={storeLinkStyle}>
            iOS App Store
          </a>
          <a href={ANDROID_APP_URL} style={storeLinkStyle}>
            Google Play Store
          </a>
        </div>
      </main>
    </div>
  );
};

const storeLinkStyle = {
  display: 'block',
  padding: '15px 30px',
  backgroundColor: '#0b61e2',
  color: 'white',
  textDecoration: 'none',
  borderRadius: '8px',
  fontWeight: 600
};

export default MobileAppDownload;
